export default __webpack_public_path__ + "static/media/exterior (10).41c4b47e.jpg";